export default __webpack_public_path__ + "img/bg-main-dark.753f69fe.svg";